/** API 根地址：开发走代理用相对路径，生产用完整域名 */
export const API_BASE = process.env.API_BASE || ''



// WEBPACK FOOTER //
// ./src/config/api.js